const formatNumber = number => {
  try {
    return number.toLocaleString();
  } catch (ex) {
    return number;
  }
};

export default formatNumber;



// WEBPACK FOOTER //
// ./src/utilities/numberFormatter.js